import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosPesajeService,
  TipoAnimalItem,
} from "../../../../../generated/grpc/catalogos_pesaje_pb";

/** Variante gRPC-Web (con delta) de `TipoAnimalGetCatalogService` (ver ese archivo). */
export class TipoAnimalGrpcCatalogService extends BaseGrpcCatalogService<TipoAnimalItem> {
  protected readonly storeName = "tiposAnimal" as const;
  protected readonly sortFieldName = "nombre";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<TipoAnimalItem>> {
    const client = createClient(CatalogosPesajeService, grpcTransportProvider.get());

    try {
      const response = await client.listTipoAnimales({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de tipos de animal. */
export const tipoAnimalGrpcCatalogService = new TipoAnimalGrpcCatalogService();
